// Test IDs for the link-in-bio page (profile, links, intake form).
// Keys camelCase, values kebab-case `<feature>-<element>`.

export const BIO = {
  page: 'bio-page',
  profileCard: 'bio-profile-card',
  profileAvatar: 'bio-profile-avatar',
  profileName: 'bio-profile-name',
  profileTitle: 'bio-profile-title',
  profileBio: 'bio-profile-bio',
  linkStack: 'bio-link-stack',
  link1: 'bio-link-prsvr',
  link2: 'bio-link-dila-design-house',
  link3: 'bio-link-scholar-athlete-academy',
  link4: 'bio-link-hit-up-coach-b',
  // Hit Up Coach B group: toggle + sub-links panel
  coachToggle: 'bio-coach-toggle',
  coachPanel: 'bio-coach-panel',
  coachSubLchaim: 'bio-coach-sub-lchaim',
  coachSubInstagramHitup: 'bio-coach-sub-instagram-hitupcoachb',
  coachSubInstagramPrsvr: 'bio-coach-sub-instagram-prsvr',
  coachSubLinkedin: 'bio-coach-sub-linkedin-prsvr',
  coachSubPatreon: 'bio-coach-sub-patreon',
  coachSubYoutube: 'bio-coach-sub-youtube',
  // Intake form
  formCard: 'bio-form-card',
  formTitle: 'bio-form-title',
  inputVisitorName: 'bio-input-visitor-name',
  inputVisitorEmail: 'bio-input-visitor-email',
  inputVisitorPhone: 'bio-input-visitor-phone',
  inputTipAmount: 'bio-input-tip-amount',
  inputProjectMessage: 'bio-input-project-message',
  selectPaymentNetwork: 'bio-select-payment-network',
  tipToggle: 'bio-tip-toggle',
  tipPanel: 'bio-tip-panel',
  submitButton: 'bio-submit-button',
  confirmationPanel: 'bio-confirmation-panel',
  confirmationName: 'bio-confirmation-name',
  confirmationEmail: 'bio-confirmation-email',
  confirmationPhone: 'bio-confirmation-phone',
  confirmationAmount: 'bio-confirmation-amount',
  confirmationMessage: 'bio-confirmation-message',
  confirmationNetwork: 'bio-confirmation-network',
  resetButton: 'bio-reset-button',
  // Footer
  footerDilaLink: 'bio-footer-dila-link',
  // Wingman email capture
  captureCard: 'bio-capture-card',
  captureTitle: 'bio-capture-title',
  captureInput: 'bio-capture-input',
  captureSubmit: 'bio-capture-submit',
  captureSuccess: 'bio-capture-success',
  captureValidationError: 'bio-capture-validation-error',
  captureServerError: 'bio-capture-server-error',
};
